import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { useParams, useHistory } from "react-router-dom"
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  ListGroup,
  ListGroupItem,
} from "reactstrap"
import {
  FaBan,
  FaShippingFast,
  FaRegHandshake,
  FaRegTimesCircle,
  FaThinkPeaks,
  FaRegCheckCircle,
  FaHistory,
} from "react-icons/fa"
import Datatables from "../utils/table/datatable"
import { MisReportsColumns } from "helpers/DatatableColumns"
import cookieHelper from "helpers/getCookieData"
import { get } from "helpers/api_helper"
import { REPORTS } from "helpers/url_helper"
import "flatpickr/dist/themes/material_red.css"
import moment from "moment"
import StatusUpdate from "./Status-update"
import NdrStatusUpdate from "./Ndr-update"

const Reports = () => {
  const { category } = useParams()
  const history = useHistory()
  const timeoutRef = useRef(null)
  
  const selectedReport = category || "Manifested"
  const [dataRows, setDataRows] = useState([])
  const [dateRange, setDateRange] = useState(() => {
    const to = new Date()
    const from = new Date()
    from.setDate(to.getDate() - 14)
    return [from, to]
  })
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    search: "",
  })

  useEffect(() => {
    setPagination(p => ({ ...p, page: 1 }));
  }, [selectedReport])

  const getIconClass = report =>
    `me-3 ${selectedReport === report ? "text-white" : "text-primary"}`

  const tokenData = cookieHelper.getCookie("_vslaccdt")
    ? JSON.parse(cookieHelper.getCookie("_vslaccdt"))
    : null

  const fetchData = async () => {
    const { success, data } = await get(
      `${REPORTS}/msi?type=${selectedReport}&limit=${pagination.limit}&page=${
        pagination.page
      }&search=${pagination.search}&_from=${moment(dateRange[0]).format(
        "YYYY-MM-DD"
      )}&_to=${moment(dateRange[1]).format("YYYY-MM-DD")}`
    )
    if (success) {
      setDataRows(data)
    }
  }

  useEffect(() => {
    if (selectedReport != "Status") {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      timeoutRef.current = setTimeout(() => {
        fetchData()
      }, 400)

      return () => clearTimeout(timeoutRef.current)
    }
  }, [dateRange, pagination, selectedReport])

  const handleDateFilter = dates => {
    if (dates.length > 1) {
      setDateRange([new Date(dates[0]), new Date(dates[1])])
    }
  }

  const navigateToReport = (reportType) => {
    history.push(`/reports/${reportType}`)
  }

  if (tokenData?.role == "client") {
    return (
      <Container fluid className="mt-5" style={{ marginBottom: "180px" }}>
        <Row>
          <Col>
            <h4>Shipments</h4>
          </Col>
          <Col></Col>
        </Row>
        <Row>
          <Col lg={3}>
            <Card>
              <CardBody>
                <ListGroup flush>
                  <ListGroupItem
                    tag="a"
                    href="#"
                    action
                    className="d-flex align-items-center"
                    active={selectedReport === "Manifested"}
                    onClick={(e) => {
                      e.preventDefault()
                      navigateToReport("Manifested")
                    }}
                  >
                    <FaRegCheckCircle className={getIconClass("Manifested")} />
                    <span>Manifested</span>
                  </ListGroupItem>
                  <ListGroupItem
                    tag="a"
                    href="#"
                    action
                    className="d-flex align-items-center"
                    active={selectedReport === "IT"}
                    onClick={(e) => {
                      e.preventDefault()
                      navigateToReport("IT")
                    }}
                  >
                    <FaShippingFast className={getIconClass("IT")} />
                    <span>In Transit</span>
                  </ListGroupItem>

                  <ListGroupItem
                    tag="a"
                    href="#"
                    action
                    className="d-flex align-items-center"
                    active={selectedReport === "RTO"}
                    onClick={(e) => {
                      e.preventDefault()
                      navigateToReport("RTO")
                    }}
                  >
                    <FaBan className={getIconClass("RTO")} />
                    <span>RTO</span>
                  </ListGroupItem>

                  <ListGroupItem
                    tag="a"
                    href="#"
                    action
                    className="d-flex align-items-center"
                    active={selectedReport === "NDR"}
                    onClick={(e) => {
                      e.preventDefault()
                      navigateToReport("NDR")
                    }}
                  >
                    <FaRegTimesCircle className={getIconClass("NDR")} />
                    <span>NDR</span>
                  </ListGroupItem>

                  <ListGroupItem
                    tag="a"
                    href="#"
                    action
                    className="d-flex align-items-center"
                    active={selectedReport === "Delivered"}
                    onClick={(e) => {
                      e.preventDefault()
                      navigateToReport("Delivered")
                    }}
                  >
                    <FaRegHandshake className={getIconClass("Delivered")} />
                    <span>Delivered</span>
                  </ListGroupItem>

                  <ListGroupItem
                    tag="a"
                    href="#"
                    action
                    className="d-flex align-items-center"
                    active={selectedReport === "MSI"}
                    onClick={(e) => {
                      e.preventDefault()
                      navigateToReport("MSI")
                    }}
                  >
                    <FaThinkPeaks className={getIconClass("MSI")} />
                    <span>MSI Report</span>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
          <Col lg={9}>
            <Datatables
              isSearch={true}
              columns={MisReportsColumns}
              showTableOnly={true}
              rowsLength={dataRows?.totalRows || 0}
              rows={dataRows?.data || []}
              keyField={"id"}
              handleAddButton={() => {}}
              title={`${
                selectedReport.charAt(0).toUpperCase() + selectedReport.slice(1)
              } Reports`}
              loading={false}
              isAdd={false}
              isTableHead={true}
              defaultDates={dateRange}
              daterange={handleDateFilter}
              ssr={setPagination}
            />
          </Col>
        </Row>
      </Container>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Reports | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          <h4>Reports</h4>
          <Row>
            <Col lg={3}>
              <Card>
                <CardBody>
                  <ListGroup flush>
                    <ListGroupItem
                      tag="a"
                      href="#"
                      action
                      className="d-flex align-items-center"
                      active={selectedReport === "Manifested"}
                      onClick={(e) => {
                        e.preventDefault()
                        navigateToReport("Manifested")
                      }}
                    >
                      <FaRegCheckCircle
                        className={getIconClass("Manifested")}
                      />
                      <span>Manifested</span>
                    </ListGroupItem>
                    <ListGroupItem
                      tag="a"
                      href="#"
                      action
                      className="d-flex align-items-center"
                      active={selectedReport === "IT"}
                      onClick={(e) => {
                        e.preventDefault()
                        navigateToReport("IT")
                      }}
                    >
                      <FaShippingFast className={getIconClass("IT")} />
                      <span>In Transit</span>
                    </ListGroupItem>

                    <ListGroupItem
                      tag="a"
                      href="#"
                      action
                      className="d-flex align-items-center"
                      active={selectedReport === "RTO"}
                      onClick={(e) => {
                        e.preventDefault()
                        navigateToReport("RTO")
                      }}
                    >
                      <FaBan className={getIconClass("RTO")} />
                      <span>RTO</span>
                    </ListGroupItem>

                    <ListGroupItem
                      tag="a"
                      href="#"
                      action
                      className="d-flex align-items-center"
                      active={selectedReport === "NDR"}
                      onClick={(e) => {
                        e.preventDefault()
                        navigateToReport("NDR")
                      }}
                    >
                      <FaRegTimesCircle className={getIconClass("NDR")} />
                      <span>NDR</span>
                    </ListGroupItem>

                    <ListGroupItem
                      tag="a"
                      href="#"
                      action
                      className="d-flex align-items-center"
                      active={selectedReport === "Delivered"}
                      onClick={(e) => {
                        e.preventDefault()
                        navigateToReport("Delivered")
                      }}
                    >
                      <FaRegHandshake className={getIconClass("Delivered")} />
                      <span>Delivered</span>
                    </ListGroupItem>

                    <ListGroupItem
                      tag="a"
                      href="#"
                      action
                      className="d-flex align-items-center"
                      active={selectedReport === "MSI"}
                      onClick={(e) => {
                        e.preventDefault()
                        navigateToReport("MSI")
                      }}
                    >
                      <FaThinkPeaks className={getIconClass("MSI")} />
                      <span>MSI Report</span>
                    </ListGroupItem>

                    <ListGroupItem
                      tag="a"
                      href="#"
                      action
                      className="d-flex align-items-center"
                      active={selectedReport === "Status"}
                      onClick={(e) => {
                        e.preventDefault()
                        navigateToReport("Status")
                      }}
                    >
                      <FaHistory className={getIconClass("Status")} />
                      <span>Status Update</span>
                    </ListGroupItem>
                  </ListGroup>
                </CardBody>
              </Card>
            </Col>
            <Col lg={9}>
              {selectedReport == "Status" ? (
                <>
                  <StatusUpdate />
                  <NdrStatusUpdate />
                </>
              ) : (
                <Datatables
                  isSearch={true}
                  columns={MisReportsColumns}
                  showTableOnly={true}
                  rowsLength={dataRows?.totalRows || 0}
                  rows={dataRows?.data || []}
                  keyField={"id"}
                  handleAddButton={() => {}}
                  title={`${
                    selectedReport == "IT"
                      ? "In Transit"
                      : selectedReport.charAt(0).toUpperCase() +
                        selectedReport.slice(1)
                  } Shipments`}
                  loading={false}
                  isAdd={false}
                  isTableHead={true}
                  defaultDates={dateRange}
                  daterange={handleDateFilter}
                  ssr={setPagination}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Reports
